import React from 'react';
import { useFormContext } from 'react-hook-form';
import { DealerType, dealerVerqorRR } from '@types';
import { SelectInput } from '@components';
import { Option } from './DealerForm';

interface Props {
  dealerType: DealerType;
  statuses: Option[];
}

export const VerqorRRInput = ({ dealerType, statuses }: Props) => {
  const { watch } = useFormContext();
  const statusId = watch('statusId');

  const allowedVerqorRRStatuses = ['unqualified', 'rejected by verqor'];
  const isDisabled = statuses
    .filter(status => allowedVerqorRRStatuses.includes(status.name.toLowerCase()))
    .some(status => String(statusId) === String(status.id));

  return (
    <SelectInput
      label={false}
      source="verqorRR"
      choices={dealerVerqorRR[dealerType].map(option => ({ id: option, name: option }))}
      disabled={!isDisabled}
    />
  );
};
